import { BackIcon } from "@/components/icons";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const QRScan = ({
  onActiveChange,
}: {
  onActiveChange: (index: number) => void;
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("QRScan");
  }, []);

  useEffect(() => {
    // 组件卸载时的清理函数
    return () => {
      // 获取所有视频流并停止
      const videoElement = document.querySelector("video");
      if (videoElement) {
        const stream = videoElement.srcObject as MediaStream;
        if (stream) {
          stream.getTracks().forEach((track) => track.stop());
        }
      }
    };
  }, []);

  const handleScan = (detectedCodes: any) => {
    if (!detectedCodes) return;

    const video = document.querySelector("video");
    const scannerBox = document.querySelector(".scanner-box");
    if (!scannerBox || !video) return;

    const videoRect = video.getBoundingClientRect();
    const boxRect = scannerBox.getBoundingClientRect();

    // 获取视频的原始尺寸
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;

    // 计算视频在屏幕上的实际显示区域
    let displayWidth = videoRect.width;
    let displayHeight = videoRect.height;
    const videoAspect = videoWidth / videoHeight;
    const containerAspect = videoRect.width / videoRect.height;

    // 根据 contain 模式计算实际显示尺寸
    if (containerAspect > videoAspect) {
      // 高度填满，宽度自适应
      displayWidth = videoRect.height * videoAspect;
      displayHeight = videoRect.height;
    } else {
      // 宽度填满，高度自适应
      displayWidth = videoRect.width;
      displayHeight = videoRect.width / videoAspect;
    }

    // 计算视频在容器中的偏移量
    const offsetX = (videoRect.width - displayWidth) / 2;
    const offsetY = (videoRect.height - displayHeight) / 2;

    // 计算新的缩放比例
    const scaleX = displayWidth / videoWidth;
    const scaleY = displayHeight / videoHeight;

    detectedCodes.forEach((code: any) => {
      const { cornerPoints } = code;

      // 检查所有角点是否都在扫描框内
      const isInBox = cornerPoints.every((point: { x: number; y: number }) => {
        // 考虑偏移量计算实际屏幕坐标
        const screenX = point.x * scaleX + offsetX + videoRect.left;
        const screenY = point.y * scaleY + offsetY + videoRect.top;

        return (
          screenX >= boxRect.left &&
          screenX <= boxRect.right &&
          screenY >= boxRect.top &&
          screenY <= boxRect.bottom
        );
      });

      console.log("调试信息：", {
        角点坐标: cornerPoints,
        缩放比例: { scaleX, scaleY },
        偏移量: { offsetX, offsetY },
        显示尺寸: { displayWidth, displayHeight },
        扫描框位置: boxRect,
        是否在框内: isInBox,
      });

      if (isInBox) {
        const qrValue = code.rawValue;
        console.log("qrValue", qrValue);

        try {
          const url = new URL(qrValue);
          console.log("url", url);
          console.log(url.hostname);
          const isValidDomain =
            url.hostname.includes("logs.money") ||
            url.hostname.includes("localhost:300");

          console.log("isValidDomain", isValidDomain);
          console.log(url.pathname);
          console.log(url.search);
          console.log(url.hash);
          if (isValidDomain) {
            const pathname = url.pathname + url.search + url.hash;
            navigate(pathname);
          } else {
            // setError("无效的二维码格式");
          }
        } catch (err) {
          //   setError("无效的二维码内容");
          console.error("二维码解析错误:", err);
        }
      }
    });
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      <Box position="relative" height="100%">
        <Scanner
          formats={["qr_code"]}
          onScan={(detectedCodes) => {
            console.log("detectedCodes", detectedCodes);
            handleScan(detectedCodes);
          }}
          onError={(error) => {
            console.log(`onError: ${error}'`);
            alert(error);
          }}
          components={{
            audio: false,
            onOff: false,
            torch: true,
            zoom: false,
            finder: false,
          }}
          allowMultiple={true}
          scanDelay={2000}
          styles={{
            container: {
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            video: {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          }}
        />
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          sx={{
            width: "250px",
          }}
        >
          <Box
            className="scanner-box"
            width="250px"
            height="250px"
            border="2px solid #fff"
            borderRadius="20px"
            // boxShadow="0 0 0 9999px rgba(0, 0, 0, 0.5)"
          />
          <VStack width="250px" spacing={2}>
            <Text
              color="white"
              fontSize="16px"
              sx={{
                textAlign: "center",
                padding: "0 20px",
                marginTop: "20px",
              }}
            >
              Please scan this QR code with any wallet app to pay
            </Text>
          </VStack>
        </Box>
      </Box>
    </Box>
  );
};

export default QRScan;
